<div class="detail-container">

  <!-- 💎 LUXURY WRAPPER (AVOIR STYLE) 💎 -->
  <div class="detail-wrapper" *ngIf="!isLoading">
    
    <!-- ── TOP HEADER: POPUP MIRROR STYLE ── -->
    <header class="popup-mirror-header">
      <div class="header-left">
        <div class="header-icon-circle">
          <i class="fa fa-university"></i>
        </div>
        <div class="header-info-group">
          <h2>Expertise en Réconciliation de Caisse</h2>
          <div class="sub-badges">
            <span class="badge-gray"><i class="fa fa-calendar-alt mr-1"></i> Audit du {{ date | date:'dd/MM/yyyy' }}</span>
            <span class="badge-gray"><i class="fa fa-database mr-1"></i> {{ availableF8s.length + availableOrderLines.length }} entrées libres</span>
            <!-- Draft indicator -->
            <span *ngIf="hasDraft" class="badge-draft" title="Brouillon sauvegardé automatiquement">
              <i class="fa fa-cloud mr-1"></i> Brouillon actif
            </span>
            <button class="status-badge-mini bg-blue-soft border-0 cursor-pointer" (click)="openProcessReport()">
              <i class="fa fa-file-invoice mr-1"></i> Voir Rapport Provisoire
            </button>
          </div>
        </div>
      </div>
      
      <div class="header-actions no-print">
        <div class="flex items-center gap-2">
          <input type="date" class="btn-back-minimal py-2" [ngModel]="date" (ngModelChange)="onDateChange($event)" />
          
          <div class="h-8 w-[1px] bg-slate-200 mx-1"></div> <!-- Separator -->

          <button (click)="resetWorkbench()" class="btn-back-minimal text-red-600 hover:bg-red-50" title="Tout effacer">
            <i class="fa fa-undo"></i> Réinitialiser
          </button>
          
          <button (click)="openProcessReport()" class="btn-action-premium" style="padding: 0.6rem 1.25rem;">
            <i class="fa fa-file-export mr-2"></i> Générer Rapport
          </button>
          
          <!-- Draft save / clear button -->
          <button *ngIf="hasDraft" (click)="clearDraft()" class="btn-back-minimal text-amber-600 hover:bg-amber-50" title="Effacer le brouillon sauvegardé pour cette date">
            <i class="fa fa-cloud-upload-alt"></i> Effacer Brouillon
          </button>

          <button (click)="goBack()" class="btn-back-minimal">
            <i class="fa fa-sign-out-alt"></i> Quitter
          </button>
        </div>
      </div>
    </header>

    <div class="popup-mirror-content">
      
      <!-- ── STATS SECTION: META CARDS GRID ── -->
      <div class="info-cards-grid">
        <div class="meta-card">
          <span class="label">Balance Caisse (F8)</span>
          <span class="value text-blue">{{ formatAmount(globalF8Total) }} MAD</span>
        </div>
        <div class="meta-card">
          <span class="label">Journal Ventes (Soft)</span>
          <span class="value text-slate">{{ formatAmount(globalLinesTotal) }} MAD</span>
        </div>
        <div class="meta-card">
          <span class="label">Écart Analytique</span>
          <span class="value" [class.text-emerald-600]="Math.abs(globalF8Total - globalLinesTotal) < 0.1" [class.text-red-500]="Math.abs(globalF8Total - globalLinesTotal) >= 0.1">
            {{ formatAmount(globalF8Total - globalLinesTotal) }} MAD
          </span>
        </div>
        <div class="meta-card">
          <span class="label">Dossiers d'Audit</span>
          <span class="value text-amber-500">{{ groups.length }} Groupes Créés</span>
        </div>
      </div>

      <!-- ── MAIN WORKBENCH GRID ── -->
      <div class="workbench-grid">
        
        <!-- 📦 LEFT: F8 AUDIT LIST -->
        <div class="audit-panel">
          <div class="panel-title">
            <span>Journal de Caisse (Tickets)</span>
            <i class="fa fa-vault"></i>
          </div>
          <div class="list-container">
            <div *ngIf="availableF8s.length === 0" class="text-center py-8 text-xs text-slate-400 italic">Aucun ticket libre</div>
            <div *ngFor="let f8 of availableF8s" 
                 class="audit-row-item animate-slide-up"
                 [class.is-reconciled]="f8.groupId"
                 [draggable]="!f8.groupId" 
                 (dragstart)="!f8.groupId && onF8DragStart(f8, $event)" 
                 (dragend)="onDragEnd()">
              <div class="item-left">
                <span class="item-time">TICKET #{{ f8.id }} • {{ f8.time }}</span>
                <span class="item-name">Encaissement F8 Manuel</span>
                <div class="flex gap-1 mt-1">
                  <span class="status-badge-mini bg-emerald-soft" *ngIf="f8.isExactMatch">{{ f8.suggestionTag }}</span>
                  <span class="status-badge-mini bg-blue-soft" *ngIf="f8.suggestionTag && !f8.isExactMatch">MATCH SUGGÉRÉ</span>
                  <span class="status-badge-mini bg-gray-soft" *ngIf="f8.groupId"><i class="fa fa-link mr-1"></i> RÉCONCILIÉ</span>
                </div>
              </div>
              <div class="item-right">
                <span class="item-amount text-blue">{{ formatAmount(f8.amount) }}</span>
                <i class="fa fa-grip-lines text-slate-200 mt-2"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- 🛠️ CENTER: INVESTIGATION WORKSPACE -->
        <div class="audit-panel center-audit-panel">
          <div class="panel-title">
            <span>Espace d'Investigation</span>
            <i class="fa fa-folder-tree"></i>
          </div>
          
          <div class="list-container">
            <div class="drop-zone-premium" 
                 [class.drag-over]="dragOverGroupId === 'new'"
                 (dragover)="onDragOver($event, 'new')" 
                 (drop)="onDrop($event, 'new')">
            <i class="fa fa-folder-open mb-2 block opacity-40"></i>
            Déposez un item ici pour ouvrir un nouveau dossier d'audit
          </div>

          <div *ngIf="groups.length === 0" class="empty-state-luxury">
            <i class="fa fa-balance-scale"></i>
            <p class="font-bold text-slate-800">Aucune investigation en cours</p>
            <p class="text-xs mt-2">Recherchez les correspondances entre les tickets F8 et les articles vendus.</p>
          </div>

          <div *ngFor="let group of groups" class="reconciliation-card animate-slide-up">
            <div class="card-header-pro">
              <div class="group-status">
                <div class="audit-indicator" [class.bg-check]="isGroupValid(group)" [class.bg-warning]="!isGroupValid(group)"></div>
                <div class="group-summary">
                  <div class="sum-item">
                    <span class="sum-label">Caisse</span>
                    <span class="sum-value text-blue">{{ formatAmount(calculateF8Total(group)) }}</span>
                  </div>
                  <div class="sum-item">
                    <span class="sum-label">Articles</span>
                    <span class="sum-value">{{ formatAmount(calculateLinesTotal(group)) }}</span>
                  </div>
                  <div class="sum-item" *ngIf="!isGroupValid(group)">
                    <span class="sum-label text-red-500">Écart</span>
                    <span class="sum-value text-red-500">{{ formatAmount(calculateDifference(group)) }}</span>
                  </div>
                </div>
              </div>
              <button class="btn-trash-minimal" (click)="deleteGroup(group)">
                <i class="fa fa-trash"></i>
              </button>
            </div>

            <div class="card-details-split">
              <!-- F8s in group -->
              <div class="detail-col" (dragover)="onDragOver($event, group.id)" (drop)="onDrop($event, group.id)" [class.active]="dragOverGroupId === group.id">
                <span class="col-label">Tickets Justificatifs</span>
                <div *ngFor="let f8 of group.f8s" class="mini-row-luxury">
                  <span class="name">{{ f8.time }}</span>
                  <div class="flex items-center gap-2">
                    <span class="amount">{{ formatAmount(f8.amount) }}</span>
                    <i class="fa fa-times btn-remove-luxury" (click)="removeFromGroup('f8', f8)"></i>
                  </div>
                </div>
              </div>
              <!-- Order lines in group -->
              <div class="detail-col" (dragover)="onDragOver($event, group.id)" (drop)="onDrop($event, group.id)" [class.active]="dragOverGroupId === group.id">
                <span class="col-label">Biens vendus</span>
                <div *ngFor="let line of group.orderLines" class="mini-row-luxury">
                  <span class="name truncate max-w-[150px]"><span class="font-bold mr-1">{{ line.quantity }}x</span> {{ line.productName }}</span>
                  <div class="flex items-center gap-2">
                    <span class="amount" [class.text-slate-400]="(line.appliedReduction || 0) > 0" [class.line-through]="(line.appliedReduction || 0) > 0">{{ formatAmount(line.totalPrice) }}</span>
                    <i class="fa fa-times btn-remove-luxury" (click)="removeFromGroup('line', line)"></i>
                  </div>
                  
                  <!-- INLINE REDUCTION INPUT (Sub-row) -->
                  <div *ngIf="(line.originalOrderDiscount || 0) > 0" class="w-full mt-2 pt-2 border-t border-slate-50 flex items-center gap-2">
                    <span class="text-[9px] font-black text-slate-400 uppercase">Remise MAD</span>
                    <input type="number" 
                           [(ngModel)]="line.appliedReduction" 
                           (ngModelChange)="recalcGroup(group)"
                           class="reduction-inline-input"
                           placeholder="0.00" />
                    <span class="text-xs font-bold ml-auto text-emerald-600" *ngIf="(line.appliedReduction || 0) > 0">
                      Net: {{ formatAmount(line.totalPrice - (line.appliedReduction || 0)) }}
                    </span>
                  </div>
                </div>
              </div>
            </div> <!-- Closes card-details-split -->
          </div> <!-- Closes reconciliation-card loop -->
        </div> <!-- Closes center list-container -->
      </div> <!-- Closes center audit-panel -->

        <!-- 🛒 RIGHT: ORDER LINES AUDIT LIST -->
        <div class="audit-panel">
          <div class="panel-title">
            <span>Journal de Ventes (Articles)</span>
            <i class="fa fa-shopping-basket"></i>
          </div>
          
          <!-- LUXURY SEARCH BAR -->
          <div class="px-3 mb-2">
            <div class="relative flex items-center" style="position: relative;">
              <i class="fa fa-search" style="position: absolute; left: 12px; font-size: 11px; color: #94a3b8;"></i>
              <input type="text" 
                     class="btn-back-minimal w-full" 
                     style="padding-left: 32px; padding-top: 8px; padding-bottom: 8px; font-size: 11px; font-weight: normal;"
                     placeholder="Rechercher un produit ou CMD #" 
                     [(ngModel)]="productSearch" />
              <button *ngIf="productSearch" 
                      (click)="productSearch = ''" 
                      style="position: absolute; right: 12px; border: none; background: transparent; color: #cbd5e1; cursor: pointer;">
                <i class="fa fa-times-circle"></i>
              </button>
            </div>
          </div>

          <div class="list-container">
            <div *ngIf="availableOrderLines.length === 0" class="text-center py-8 text-xs text-slate-400 italic">Rien à auditer</div>
            <div *ngFor="let line of availableOrderLines" 
                 class="audit-row-item animate-slide-up"
                 draggable="true" 
                 (dragstart)="onLineDragStart(line, $event)" 
                 (dragend)="onDragEnd()">
              <div class="item-left">
                <span class="item-time">{{ line.time }} • CMD #{{ line.originalOrderId }}</span>
                <span class="item-name"><span class="font-black text-blue-600 mr-1">{{ line.quantity }}x</span> {{ line.productName }}</span>
                <div class="flex gap-1 mt-1">
                  <span class="status-badge-mini bg-emerald-soft" *ngIf="line.isExactMatch">{{ line.suggestionTag }}</span>
                  <span class="status-badge-mini bg-amber-soft" *ngIf="line.isSplit">✂️ DÉTACHÉ</span>
                  <span class="status-badge-mini bg-blue-soft" *ngIf="line.suggestionTag && !line.isExactMatch">MATCH SUGGÉRÉ</span>
                </div>
              </div>
              <div class="item-right">
                <span class="item-amount text-slate">{{ formatAmount(line.totalPrice) }}</span>
                <button *ngIf="line.quantity > (line.unit === 'P' ? 1 : 0.001)" 
                        (click)="openSplitModal(line); $event.stopPropagation()" 
                        class="btn-icon-more h-8 w-8 text-blue-500 mt-2" title="Détacher une quantité précise">
                  <i class="fa fa-cut"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- ── LUXURY REPORT MODAL ── -->
  <div class="luxury-modal-backdrop" *ngIf="isProcessModalOpen">
    <div class="luxury-modal-box animate-slide-up">
      <div class="modal-header-mirror">
        <h3>Synthèse de l'Audit Hebdomadaire</h3>
        <button class="btn-icon-more border-0" (click)="isProcessModalOpen = false"><i class="fa fa-times"></i></button>
      </div>

      <div class="modal-body-grid">
        
        <div class="financial-breakdown-card success">
          <div class="card-title-pro"><i class="fa fa-check-circle text-emerald-500"></i> Dossiers Validés</div>
          <div class="flex flex-col gap-2">
            <div *ngFor="let m of processSummary.validGroups" class="report-item-pro">
              <span class="font-bold">Investigation #{{ m.id.slice(-4) }}</span>
              <span class="text-emerald-700 font-bold">{{ formatAmount(calculateF8Total(m)) }} MAD</span>
            </div>
            <p *ngIf="processSummary.validGroups.length === 0" class="text-xs text-slate-400 italic">Aucune validation définitive</p>
          </div>
        </div>

        <div class="financial-breakdown-card danger">
          <div class="card-title-pro"><i class="fa fa-exclamation-triangle text-red-500"></i> Écarts Critiques</div>
          <div class="flex flex-col gap-2">
            <div *ngFor="let d of processSummary.incompleteGroups" class="report-item-pro">
              <span>Dossier #{{ d.id.slice(-4) }}</span>
              <span class="text-red-700 font-black">Écart : {{ formatAmount(calculateDifference(d)) }} MAD</span>
            </div>

            <!-- NOUVEAU : Afficher les tickets orphelins comme des écarts critiques -->
            <div *ngIf="processSummary.excessF8s.length > 0" class="report-item-pro bg-red-50/50 border-red-100">
              <span class="text-red-600 font-bold">Fonds non justifiés (Tickets)</span>
              <span class="text-red-700 font-black">{{ formatAmount(calculateTotalExcessF8()) }} MAD</span>
            </div>

            <p *ngIf="processSummary.incompleteGroups.length === 0 && processSummary.excessF8s.length === 0" class="text-xs text-slate-400 italic">Aucun écart majeur détecté</p>
          </div>
        </div>

        <div class="financial-breakdown-card info">
          <div class="card-title-pro"><i class="fa fa-cash-register text-blue-500"></i> Tickets Résiduels</div>
          <div class="flex flex-wrap gap-2 mt-1">
            <span class="badge-gray" *ngFor="let f of processSummary.excessF8s">
              {{ f.time }} - <strong>{{ formatAmount(f.amount) }}</strong>
            </span>
            <p *ngIf="processSummary.excessF8s.length === 0" class="text-xs text-slate-400 italic">Tous les fonds sont justifiés</p>
          </div>
        </div>

        <div class="financial-breakdown-card warning">
          <div class="card-title-pro"><i class="fa fa-file-invoice text-amber-500"></i> Ventes non justifiées</div>
          <div class="flex flex-col gap-2">
            <div *ngFor="let l of processSummary.missingF8Lines" class="report-item-pro">
              <span class="truncate font-bold">{{ l.quantity }}x {{ l.productName }}</span>
              <span class="font-bold text-slate-700">{{ formatAmount(l.totalPrice) }} MAD</span>
            </div>
            <p *ngIf="processSummary.missingF8Lines.length === 0" class="text-xs text-slate-400 italic">Tous les produits sont payés</p>
          </div>
        </div>

      </div>

      <div class="modal-footer-lux">
        <p class="text-[10px] text-slate-400 italic max-w-sm">Ce rapport constitue une pièce de justification pour l'audit comptable. Les transactions orphelines seront consolidées en fin de mois.</p>
        <button class="btn-action-premium" (click)="closeProcessReport()">Terminer la Session</button>
      </div>
    </div>
  </div>

  <!-- ── SMART DETACH (SPLIT) MODAL ── -->
  <div *ngIf="isSplitModalOpen" class="modal-overlay-lux">
    <div class="split-modal-lux animate-slide-up">
      <div class="modal-header-lux">
        <div>
          <h3 class="font-black text-slate-800 text-lg">
            {{ isSplitByAmount ? 'Détacher un montant (DH)' : 'Détacher une quantité' }}
          </h3>
          <p class="text-[9px] text-slate-400 uppercase font-black tracking-[0.2em] mt-0.5">
            {{ isSplitByAmount ? 'Produit Non Stocké — Split par Montant' : 'Audit de Précision' }}
          </p>
        </div>
        <button (click)="closeSplitModal()" class="h-10 w-10 rounded-full hover:bg-slate-50 text-slate-300 hover:text-slate-600 flex items-center justify-center transition-all">
          <i class="fa fa-times text-sm"></i>
        </button>
      </div>

      <div class="split-modal-body">
        <div class="product-preview-hint">
          <p class="text-[9px] uppercase font-black text-slate-400 mb-1 tracking-widest">Produit</p>
          <p class="text-sm font-bold text-slate-700 leading-tight">{{ splitTargetLine?.productName }}</p>
          <p class="text-[10px] text-slate-400 mt-0.5">
            Total : <span class="font-bold text-slate-600">{{ formatAmount(splitTargetLine?.totalPrice || 0) }} MAD</span>
          </p>
          
          <!-- VISUAL BALANCE BAR (adapts to mode) -->
          <div class="balance-bar-container">
            <div class="balance-segment detached" [style.width.%]="getSplitProgressPct()"></div>
            <div class="balance-segment remaining" [style.width.%]="100 - getSplitProgressPct()"></div>
          </div>
        </div>

        <!-- ── MODE: DH AMOUNT (non-stocked product) ── -->
        <div class="mt-2" *ngIf="isSplitByAmount">
          <label class="text-[10px] uppercase font-black text-slate-400 mb-2 block tracking-widest ml-1">Montant à extraire (DH)</label>
          <div class="split-qty-input-container">
            <input type="number" 
                   [(ngModel)]="splitAmountInput" 
                   step="0.01"
                   [min]="0.01"
                   [max]="(splitTargetLine?.totalPrice || 1) - 0.01"
                   autocomplete="off"
                   autoFocus />
            <span class="unit-tag-lux">DH</span>
          </div>

          <!-- SLIDER -->
          <input type="range" 
                 class="lux-range-slider"
                 [(ngModel)]="splitAmountInput"
                 step="0.01"
                 [min]="0.01"
                 [max]="(splitTargetLine?.totalPrice || 1) - 0.01" />

          <!-- FINANCIAL IMPACT -->
          <div class="split-impact-grid">
            <div class="impact-card">
              <span class="lbl">À Détacher</span>
              <span class="val text-blue-600">{{ formatAmount(splitAmountInput) }} MAD</span>
              <span class="text-[10px] text-slate-400 font-bold">1 article non stocké</span>
            </div>
            <div class="impact-card">
              <span class="lbl">Reste en ligne</span>
              <span class="val text-slate-500">{{ formatAmount(getSplitRemainingValue()) }} MAD</span>
              <span class="text-[10px] text-slate-400 font-bold">1 article non stocké</span>
            </div>
          </div>
        </div>

        <!-- ── MODE: QTY (stocked product) ── -->
        <div class="mt-2" *ngIf="!isSplitByAmount">
          <label class="text-[10px] uppercase font-black text-slate-400 mb-2 block tracking-widest ml-1">Quantité à extraire</label>
          <div class="split-qty-input-container">
            <input type="number" 
                   [(ngModel)]="splitQtyInput" 
                   [step]="splitTargetLine?.unit === 'P' ? 1 : 0.01"
                   [min]="splitTargetLine?.unit === 'P' ? 1 : 0.001"
                   [max]="(splitTargetLine?.quantity || 1) - (splitTargetLine?.unit === 'P' ? 1 : 0.001)"
                   autocomplete="off"
                   autoFocus />
            <span class="unit-tag-lux">{{ splitTargetLine?.unit || 'UNIT' }}</span>
          </div>

          <!-- SMART SLIDER -->
          <input type="range" 
                 class="lux-range-slider"
                 [(ngModel)]="splitQtyInput"
                 [step]="splitTargetLine?.unit === 'P' ? 1 : 0.01"
                 [min]="splitTargetLine?.unit === 'P' ? 1 : 0.001"
                 [max]="(splitTargetLine?.quantity || 1) - (splitTargetLine?.unit === 'P' ? 1 : 0.001)" />
          
          <!-- FINANCIAL IMPACT PREVIEW -->
          <div class="split-impact-grid">
            <div class="impact-card">
              <span class="lbl">À Détacher</span>
              <span class="val text-blue-600">{{ formatAmount(getSplitAmountValue()) }} MAD</span>
              <span class="text-[10px] text-slate-400 font-bold">{{ splitQtyInput }} {{ splitTargetLine?.unit }}</span>
            </div>
            <div class="impact-card">
              <span class="lbl">Reste en ligne</span>
              <span class="val text-slate-500">{{ formatAmount(getSplitRemainingValue()) }} MAD</span>
              <span class="text-[10px] text-slate-400 font-bold">{{ getSplitRemainingQty() | number:'1.0-3' }} {{ splitTargetLine?.unit }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="px-8 pb-8 flex justify-end gap-4">
        <button class="px-6 py-3 text-xs font-bold text-slate-400 hover:text-slate-700 transition-colors" (click)="closeSplitModal()">Annuler</button>
        <button class="btn-action-premium" (click)="confirmSplit()" style="padding: 1rem 2.5rem; font-size: 0.85rem; border-radius: 18px;">Détacher l'article</button>
      </div>
    </div>
  </div>

  <!-- ── LOADING OVERLAY ── -->
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-60">
    <div class="spinner-lux"></div>
    <p class="mt-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest">Sychronisation en cours...</p>
  </div>

</div>
